import { CloseFullscreenRounded, OpenInFullRounded } from "@mui/icons-material";
import { Card, CardHeader, Divider, IconButton, Stack, SxProps, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useBreakpoints, useSettings, useSignalR } from "src/hooks";
import { queryKeys, useGetTeamFeed } from "src/http";
import { Feed } from "../../../../components";
import { CommentSubject, TeamOverviewSection } from "../../../../constants";
import { useTeamPageLayoutContext } from "../../TeamPageLayout";

interface IProps {
  sx?: SxProps;
}

const TeamFeed = (props: IProps) => {
  const { team } = useTeamPageLayoutContext();
  const { data, isLoading } = useGetTeamFeed(team?.guid, team?.slug);
  const { teamOverviewSettings, updateTeamOverviewSettings } = useSettings();
  const queryClient = useQueryClient();
  const signalR = useSignalR();
  const { isMdUp } = useBreakpoints();

  useEffect(() => {
    const handleShouldRefetchComments = (teamGuid: string) => {
      queryClient.invalidateQueries(queryKeys.teams.getTeamFeed(teamGuid));
    };

    signalR.onShouldRefetchComments(handleShouldRefetchComments);
    return () => signalR.offShouldRefetchComments(handleShouldRefetchComments);
  }, [queryClient, signalR]);

  return (
    <Card
      sx={{
        ...props.sx,
      }}
    >
      <CardHeader
        title={
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Typography variant="h6">Feed</Typography>
            {isMdUp && (
              <IconButton
                variant="tertiary"
                onClick={() => {
                  updateTeamOverviewSettings({
                    expandedSection:
                      teamOverviewSettings.expandedSection === TeamOverviewSection.Feed
                        ? undefined
                        : TeamOverviewSection.Feed,
                  });
                  window.scrollTo({ top: 0 });
                }}
              >
                {teamOverviewSettings.expandedSection === TeamOverviewSection.Feed ? (
                  <CloseFullscreenRounded />
                ) : (
                  <OpenInFullRounded />
                )}
              </IconButton>
            )}
          </Stack>
        }
      />
      <Divider />

      <Feed
        subjectType={CommentSubject.Team}
        subjectGuid={team.guid}
        isLoading={isLoading}
        items={data?.feed ?? []}
        scrolling
      />
    </Card>
  );
};

export { TeamFeed };
